module.exports = __webpack_public_path__ + "img/shoulder-mesomorph-male.1f469911.svg";